import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import Logo from '../../assets/Logo.png'
import { useLocation } from "react-router-dom";

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

   const location = useLocation()

   console.log(location.pathname)

  return (
    <header className="w-full bg-white shadow-md fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4 md:py-6">
        {/* Logo */}
        <div className="text-2xl font-bold tracking-wide" onClick={()=>window.location.href='/'}>
          <img src={Logo} alt="VetriPipeline Logo" className="h-8 w-auto" />
        </div>
        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-8 text-gray-700 ">
          <a href="/" className={location.pathname === "/" ? "text-primary-500" : "hover:text-black transition"}>Home</a>
          <a href="/about" className={location.pathname === "/about" ? "text-primary-500" : "hover:text-black transition"}>About</a>
          <a href="/services" className={location.pathname === "/services" ? "text-primary-500" : "hover:text-black transition"}>Services</a>
          <a href="/projects" className={location.pathname === "/projects" ? "text-primary-500" : "hover:text-black transition"}>Projects</a>
        </nav>

        {/* Contact Button */}
        <div className="hidden md:block">
          <button className="bg-primary-500 text-white px-5 py-2 rounded-md hover:bg-primary-600 transition">
            Contact Us
          </button>
        </div>

        {/* Mobile Icon */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white shadow-lg px-6 transition-all duration-300 overflow-hidden ${isOpen ? "max-h-96 py-5" : "max-h-0"
          }`}
      >
        <a href="/" className={`block py-2 text-gray-700 ${location.pathname === "/" ? "text-primary-500" : ""}`}>Home</a>
        <a href="/about" className={`block py-2 text-gray-700 ${location.pathname === "/about" ? "text-primary-500" : ""}`}>About</a>
        <a href="/services" className={`block py-2 text-gray-700 ${location.pathname === "/services" ? "text-primary-500" : ""}`}>Services</a>
        <a href="/projects" className={`block py-2 text-gray-700 ${location.pathname === "/projects" ? "text-primary-500" : ""}`}>Projects</a>

        <button className="w-full mt-4 bg-primary-500 text-white py-2 rounded-md">
          Contact Us
        </button>
      </div>
    </header>
  );
};